module.exports = __webpack_public_path__ + "static/steve-7409a35fb4c712e9e0ad3e4232593c1b.png";